import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export const downloadSalesExcel = (data, fromdate, todate) => {
  const formattedFromDate = fromdate
    ? new Date(fromdate).toLocaleDateString()
    : "N/A";
  const formattedToDate = todate
    ? new Date(todate).toLocaleDateString()
    : "N/A";

  const processedData = data.map((item, index) => {
    return {
      "S No": index + 1,
      Date: item.bill_date || "N/A",
      "Receipt No": item.bill_no || "N/A",
      "Party Name": item.party_name || "N/A",
      "Phone Number": item.mobile_number || "N/A",
      SubTotal: parseFloat(item.sub_total || 0).toFixed(2),
      "Tax Amount": item.gst_amount || "N/A",
      Discount: parseFloat(item.discount_amount || 0).toFixed(2),
      "Grand Total": parseFloat(item.total || 0).toFixed(2),
      Remark: item.remark || "N/A",
    };
  });

  // Calculate summary values
  const subTotal = data.reduce(
    (acc, item) => acc + parseFloat(item.sub_total || 0),
    0
  );
  const subGrandTotal = data.reduce(
    (acc, item) => acc + parseFloat(item.total || 0),
    0
  );
  const discount = data.reduce(
    (acc, item) => acc + parseFloat(item.discount_amount || 0),
    0
  );

  // Add summary row
  processedData.push({
    "S No": "Total",
    Date: "",
    "Receipt No": "",
    "Party Name": "",
    "Phone Number": "",
    SubTotal: subTotal.toFixed(2),
    Discount: discount.toFixed(2),
    "Grand Total": subGrandTotal.toFixed(2),
  });

  // Create workbook and worksheet
  const worksheet = XLSX.utils.json_to_sheet(processedData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sales Report");

  // Add metadata
  XLSX.utils.sheet_add_aoa(
    worksheet,
    [[`Sales Report: ${formattedFromDate} to ${formattedToDate}`], []],
    { origin: "A1" }
  );

  // Adjust column widths
  const colWidths = [
    { wpx: 50 }, // S No
    { wpx: 100 }, // Date
    { wpx: 120 }, // Receipt No
    { wpx: 200 }, // Party Name
    { wpx: 150 }, // Phone Number
    { wpx: 100 }, // SubTotal
    { wpx: 120 }, // Inc Tax Amount
    { wpx: 100 }, // Discount
    { wpx: 120 }, // Grand Total
    { wpx: 120 }, // Remark
  ];
  worksheet["!cols"] = colWidths;

  // Convert to Excel file and trigger download
  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
  saveAs(blob, `SalesReport_${formattedFromDate}_to_${formattedToDate}.xlsx`);
};
